import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Login from '../components/Login.vue';
import Dashboard from '../components/Dashboard.vue';
import Marketing from '../components/Marketing.vue';
import WorkEditor from '../components/WorkEditor.vue';
import Members from '../components/Members.vue';
import ResetPassword from '../components/ResetPassword.vue';
import NotFound from '../components/NotFound.vue';
import store from '../store'
import Assign from "@/components/Assign.vue";

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const routes = [
  { path: '/', name: 'login', component: Login },
  { path: '/password/recover', name: 'reset_password', component: ResetPassword },
  { path: '/assign', name: 'assign', component: Assign, beforeEnter: ifAuthenticated },
  { path: '/marketing', name: 'marketing', component: Marketing, beforeEnter: ifAuthenticated },
  { path: '/work/create', name: 'work_create', component: WorkEditor, beforeEnter: ifAuthenticated },
  { path: '/work/:id', name: 'work_editor', component: WorkEditor, beforeEnter: ifAuthenticated },
  { path: '/dashboard', name: 'dashboard', component: Dashboard, beforeEnter: ifAuthenticated },
  { path: '/members', name: 'members', component: Members, beforeEnter: ifAuthenticated },
  { path: '*', component: NotFound }
]

const router = new VueRouter({
  mode: 'history',
  routes // short for `routes: routes`
})

export default router

